<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="rtProcessTypes"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="类型编号">
              <el-input v-model.trim="filter.processTypeNo" placeholder="请输入类型编号" clearable/>
            </el-form-item>
            <el-form-item label="类型名称">
              <el-input v-model.trim="filter.processTypeName" placeholder="请输入类型名称" clearable/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
      <process-type-edit ref="editPage" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import ProcessTypeEdit from "@/views/information/ProcessTypeManagement/ProcessTypeEdit";
  export default {
    name: "ProcessTypeManagementList",
    components: { ProcessTypeEdit, ViewTable},
    data() {
      return {
        limits:{
          addAuth: this.$auth(200),
          editAuth: this.$auth(202),
          delAuth: this.$auth(203),
        },
        delAllAuth: this.$auth(201),
        selection: [],
        filter: {
          processTypeNo: "",
          processTypeName: "",
        },
        columnsProperty:[
          {
            key:"processTypeNo",
            align:"left",
          },
          {
            key:"processTypeName",
            align:"left",
          },
          {
            key:"creatorName",
            align:"center",
            width:120,
          },
          {
            key:"createTime",
            align:"center",
            width:160,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "rtProcessTypes", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "rtProcessTypes/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
